import styled, { css, keyframes } from 'styled-components'
// import CardContainer from 'live/components/ui/CardContainer'
import CardContainer from '../components/CardContainer'
import { EmptyData } from '@intelie/ui'
import { Button } from 'react-bootstrap'
import LiveModal from 'live/components/ui/Modal'
import { InputContainer } from 'plugin-liverig/shared/asset/components/Fieldset'

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`
export const StyledLiveModal = styled(LiveModal)`
    z-index: 1040;
    .form-input {
        background: ${({ theme }) => theme.white};
        height: 34px;
        border: 1px solid #ccc;
        padding-left: 10px;
    }
    .form-group,
    li.input {
        margin-bottom: 18px;
    }
    .react-datepicker-popper {
        z-index: 2;
    }
    .action-toggle {
        z-index: 1;
    }
    .required::after {
        content: '*';
        color: rgb(217, 83, 79);
        padding-left: 2px;
    }
    .fa-calendar {
        color: #2b7ab5;
        cursor: pointer;
    }
    input {
        border-radius: 3px;
    }
`
export const InputContainerDatepickerStyled = styled(InputContainer)`
    .react-datepicker__navigation--previous {
        left: 1em !important;
    }
    .react-datepicker__navigation--next {
        right: 1em !important;
    }
    .react-datepicker {
        width: 100%;
    }
    .input-group {
        display: flex;
    }
`
export const ContainerDate = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 5px;
    margin-bottom: 18px;
    > div {
        flex-grow: 5;
    }
    > div:first-child {
        margin-right: 20px;
    }
    .input-group-addon {
        padding-right: 0 !important;
        padding-top: 12px !important;
    }
    input {
        background: ${({ theme }) => theme.white};
        border: 1px solid #ccc;
        margin-top: 3px;
        border-radius: 3px;
        height: 34px;
        padding-left: 10px;
    }
`
export const ContentBody = styled.div`
    label {
        margin-bottom: 5px;
    }
`
export const OptionContent = styled.div`
    input[type='checkbox'] {
        border-radius: 0px !important;
    }

    .checkbox {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        border-radius: 5px !important;
    }
    .checkbox label {
        cursor: pointer;
        padding-right: 3px;
        font-size: 1.2rem;
        color: ${({ theme }) => theme['auxiliar-typography']};
    }
    .SelectAll {
        margin-bottom: 12px;

        label {
            color: ${({ theme }) => theme['text-color']};
            cursor: pointer;
            font-weight: bold;
            font-family: ${props => props.theme['font-regular']};
        }
    }
    .nameRadio {
        margin-left: 3px;
    }
`
export const TooltipContent = styled.div`
    position: relative;
    left: 0;
    font-size: 14px;
    margin-top: 1px;
    margin-left: 10px;
    margin-right: 10px;
    color: ${({ theme }) => theme['brand-primary']};
`
export const PopUpContent = styled.span`
    div {
        margin-top: 8px;
    }
    margin-top: 15px;
    margin-bottom: 15px;
`
export const StyledButton = styled(Button)`
    &.trans {
        color: ${({ theme }) => theme['brand-primary']} !important;
        background-color: transparent !important;
        border-color: transparent !important;
    }
    &.solid {
        color: white !important;
        background-color: ${({ theme }) => theme['brand-primary']} !important;
        border-color: ${({ theme }) => theme['brand-primary']} !important;
        outline: 0;
    }

    &.danger {
        color: white !important;
        background-color: rgb(217, 83, 79) !important;
        border-color: rgb(217, 83, 79) !important;
        outline: 0;
    }

    &:hover,
    :focus,
    :disabled {
        color: ${({ theme }) => theme['brand-primary']};
        background-color: transparent;
        border-color: transparent;
        outline: 0;
    }

    > i {
        &.need-to-rotate {
            animation: ${rotate} 1s infinite linear;
            animation-timing-function: cubic-bezier(0.42, 0.2, 0.58, 1);
        }
    }
`
export const StyledCardContainer = styled(CardContainer)`
    > header {
        > div:first-of-type {
            text-transform: uppercase;
        }
    }

    ${({ editing }) =>
        editing &&
        css`
            border: 1px solid ${({ theme }) => theme['brand-primary']};
            && {
                && {
                    opacity: 1;
                    pointer-events: all;
                }
            }

            > header {
                background-color: ${({ theme }) => theme['gray-lighter']};
                border-top-left-radius: 3px;
                border-top-right-radius: 3px;
            }
            > footer {
                border-bottom-left-radius: 3px;
                border-bottom-right-radius: 3px;
            }
        `}

    > * {
        padding: 0px 0px 10px 0px;
    }

    .capitalize {
        text-transform: capitalize;
    }
`
export const Actions = styled.div`
    display: flex;
    justify-content: right;
    margin-top: 10px;
    button {
        width: auto;
        &:disabled {
            opacity: 0.4;
        }
        float: right;
    }
`
export const StyledEmptyData = styled(EmptyData)`
    height: 178px;
`
export const StyledOverlay = styled.div`
    &.inner {
        position: absolute;
        z-index: 9999;
        width: 95%;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`
export const StyledTableControls = styled.div`
    display: flex;
    justify-content: right;
    padding-bottom: 0;
`
export const Container = styled.div`
    margin-top: 5px;
    display: block;
    > div:first-child {
        margin-right: 22px;
    }
    header {
        font-size: 1.4rem;
        font-weight: bold;
        padding-bottom: 10px;
        > subtitle {
            display:block;
            font-size: 1.2rem;
            font-style: italic;
            font-weight: normal;
            padding-top
        }
    }
    
    label {
        margin-bottom: 0 !important;
    }
    input {
        border-radius: 6px !important;
    }
    alertnote {
        font-size: 1rem;
        margin-top: 5px;
        font-style: italic;
        color: red;
    }
    note {
        font-size: 1.2rem;
    }
`
export const FormConfig = styled.div`
    div.form-group {
        margin-bottom: 10px;
        label {
            font-size: 12px;
        }
    }

    .choose-standard-title {
        margin-bottom: 10px;

        .choose-standard-title-label {
            font-size: 1.3rem;
        }
    }

    .radio-inline {
        padding-left: 0px;
        padding: 6px 30px 0px 0px;
    }

    section {
        border: solid 1px var(--gray-400);
        background: var(--gray-200);
        padding: 10px;
    }
`
